import React from 'react';
import {NavLink} from "react-router-dom";
import {PiWarehouseDuotone} from "react-icons/pi";
import {MdPallet, MdPrecisionManufacturing} from "react-icons/md";
import {ImLab} from "react-icons/im";
import {IoSettingsOutline} from "react-icons/io5";
import { BiSolidReport } from "react-icons/bi";
import { MdOutlineDevicesOther } from "react-icons/md";
import { FaHotel } from "react-icons/fa";
import { IoPrintSharp } from "react-icons/io5";
import {FaRegCircle} from "react-icons/fa";
import {hasPermission} from "../microComponents/elements/Permission/hasPermission";

const SidebarJson = () => {
    const childIcon = <FaRegCircle size={11}/>

    function getItem(label, href, key, icon, children, permission) {
        if (hasPermission(permission)) {
            return {
                key,
                className: !children?.length && '!flex items-center',
                icon,
                children,
                label: href ? <NavLink to={href}>
                    <div className='flex items-center gap-2'>{label}</div>
                </NavLink> : <div className='flex items-center gap-2'>{label}</div>


            };
        } else {
            return null
        }

    }


    const items = [getItem('شناسه های اموال', '/PalletStatus', '/PalletStatus', <MdOutlineDevicesOther size={23}/>, '', ["ViewPallet"]),

        getItem('تاریخچه شناسه','/seriesHistory', '/seriesHistory', <IoPrintSharp size={23}/>,'',["ProduceSeriView", "WarehouseSeriView"]),

		getItem('واحدهای هتل', null, '1', <FaHotel
                size={23}/>, [getItem('واحدها', '/', '/', childIcon, '', ["Map"]),
               // getItem('صدور شناسه اموال', '/PalletIdStore', '/PalletIdStore', childIcon, '', ["Warehouse"]),

                getItem('حواله خروج اموال', '/order', '/order', childIcon, '', ["Order", 'Warehouse']),

            ], ["Order", 'Warehouse', 'Map']
        ),

			// [
            // //getItem('سری تولید', '/productionLine', '/productionLine', childIcon, '', ["Seri"]),
            // getItem('تاریخچه شناسه ها', '/seriesHistory', '/seriesHistory', childIcon, '', ["ProduceSeriView", "WarehouseSeriView"]),
            // // getItem('صدور شناسه اموال', '/PrintPallet', '/PrintPallet', childIcon, '', ["SeriAdmin"]),
            // //getItem('پرینت شناسه ', '/PalletIdProduction', '/PalletIdProduction', childIcon, '', ["Print"]),
            // //getItem('صف پرینت', '/PrintQueue', '/PrintQueue', childIcon, '', ["Print", "WarehouseQueue", "ProduceQueue", "QcQueue"]),


        // ]
		// , ["Seri", 'ProduceSeriView', 'WarehouseSeriView', 'SeriAdmin', 'Print', 'WarehouseQueue', 'ProduceQueue', 'QcQueue']),
        // getItem('کنترل کیفی', null, '2', <ImLab
            // size={23}/>, [
            // getItem('بچ', '/Batch', '/Batch', childIcon, '', ["Qc"]),
            // getItem('تاریخچه بچ', '/BatchHistory', '/BatchHistory', childIcon, '', ["Qc"]),
            // getItem('بازسازی', '/PalletRebuild?qcStatus=3', '/PalletRebuild', childIcon, '', ["Qc"]),


        // ], ["Qc"]),

		getItem('گزارش موجودی', '/report/inventory', '/report/inventory', <BiSolidReport size={23}/>, '', ["Qc","Map"]),
        // getItem('گزارش ها', null, '5', <BiSolidReport
            // size={23}/>, [
           // // getItem('گزارش بچ', '/report/batchHistory', '/report/batchHistory', childIcon, '', ["Qc"]),
            // //getItem('گزارش سری تولید', '/report/productSeries', '/report/productSeries', childIcon, '', ["Qc"]), 
			// getItem('گزارش موجودی', '/report/inventory', '/report/inventory', childIcon, '', ["Qc"]),
            // getItem('گزارش موجودی گذشته', '/report/oldInventory', '/report/oldInventory', childIcon, '', ["Qc"]),
            // getItem('گزارش ورود خروج', '/report/palletEntry', '/report/palletEntry', childIcon, '', ["Qc"]),


        // ], ["Map"]),




        getItem('تنظیمات', null, '4', <IoSettingsOutline
            size={23}/>, [
            getItem('کاربران', '/UserManagement', '/UserManagement', childIcon, '', ["User"]),
            getItem('کالاها', '/ProductManagement', '/ProductManagement', childIcon, '', ["Product"]),

        ], ["User", "Product"], 'Product'),


        // getItem('ورودی و خروجی', '/EntranceExit', '/EntranceExit', <CgArrowsExchangeAltV title='ورودی و خروجی'
        //                                                                                  size={23}/>,),

    ];

    return [items];
};

export default SidebarJson;